module.exports = __webpack_public_path__ + "static/media/kp.69b9a975.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kp.svg
// module id = 863
// module chunks = 0